import { connect } from "react-redux";

import AgentMatches from "./AgentMatches";

const mapStateToProps = ({ agentsView: { agentProfile } }) => ({
  agentProfile,
});

export default connect(mapStateToProps)(AgentMatches);
